export default {
    props: {
        'count': {
            type: Number
        }
    },
    data() {
        return {
            back: false,
            currentIndex: 0,
            resetTimer: true,
            intervalId: null
        }
    },
    watch: {
        currentIndex(newIndex, oldIndex) {
            if (newIndex > oldIndex)
                this.back = true
            else
                this.back = false
        }
    },
    computed: {
        nextIndex(){
            if (this.currentIndex == this.count - 1)
                return 0
            else
                return this.currentIndex + 1
        },
        previousIndex(){
            if (this.currentIndex == 0)
                return this.count - 1
            else
                return this.currentIndex - 1
        },
        transitionName(){
            if(this.back)
                return 'slide-right invisible'
            return 'slide-left invisible'
        }
    },
    methods: {
        goto(index) {
            this.resetTimer = true
            this.currentIndex = index
            // console.log(this.currentIndex);
        },
        next(){
            this.goto(this.nextIndex)
        },
        previous(){
            this.goto(this.previousIndex)
        },
        startInterval(){
            this.stopInterval();
            this.intervalId = setInterval(() => {
                // console.log("interval expired");
                if (this.resetTimer){
                    // console.log("interval reset");
                    return this.resetTimer = false
                }
                // console.log("interval executing");
                this.next()
            }, 5000);
        },
        stopInterval(){
            if(!this.intervalId){
                return;
            }
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    },
}